// Giá trị enum tăng dần giảm dần
export default {
  BuiltIn: 0, // Ứng dụng tích hợp sẵn
  Porting: 1, // Ứng dụng Porting
  IntegratedApp: 2, // Ứng dụng tích hợp
  AmisApp: 3, // Ứng dụng Amis
};